import { _ as _defineProperty } from './defineProperty-DmV7cVMj.js';
import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './index-B0Q3DaKR.js';
import { _ as _slicedToArray } from './slicedToArray-DvtHmgP0.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-DN7d1SzH.js';
import { memo, useState, useEffect } from 'react';
import classNames from 'classnames';
import fetchWithTimeout from './fetchWithTimeout/index.js';
import Logger from './services/logger/index.js';
import { u as useSvgIconStyles, S as SvgIcons } from './styles-Qd3BEBIx.js';
import { j as jsxRuntimeExports } from './jsx-runtime-DPHDmO8O.js';

var _excluded = ["name", "onClick", "className", "role", "ariaHidden", "tabIndex", "dataTestId", "withConsole"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var iconsCache = new Map();
function SvgIcon(_ref) {
  var name = _ref.name,
    onClick = _ref.onClick,
    _ref$className = _ref.className,
    className = _ref$className === undefined ? '' : _ref$className,
    _ref$role = _ref.role,
    role = _ref$role === undefined ? 'presentation' : _ref$role,
    ariaHidden = _ref.ariaHidden,
    tabIndex = _ref.tabIndex,
    dataTestId = _ref.dataTestId,
    withConsole = _ref.withConsole,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    svg = _useState2[0],
    setSvg = _useState2[1];
  var classes = useSvgIconStyles();
  useEffect(function () {
    var raceCondition = false;
    _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var iconUrl, res, svgText;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            iconUrl = SvgIcons[name];
            if (iconUrl) {
              _context.next = 4;
              break;
            }
            Logger.warn("There isn't any icon with this '".concat(name, "' name"), withConsole);
            return _context.abrupt("return");
          case 4:
            if (!iconsCache.has(iconUrl)) {
              try {
                iconsCache.set(iconUrl, fetchWithTimeout(iconUrl, {
                  withoutLanguageHeader: true,
                  withoutDeviceId: true
                }));
              } catch (err) {
                console.log(err);
              }
            }
            _context.prev = 5;
            _context.next = 8;
            return iconsCache.get(iconUrl);
          case 8:
            res = _context.sent;
            _context.next = 11;
            return res.clone().text();
          case 11:
            svgText = _context.sent;
            if (!raceCondition) {
              setSvg(svgText);
            }
            _context.next = 18;
            break;
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            console.log('Error fetching SVG: ', _context.t0);
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[5, 15]]);
    }))();
    return function () {
      raceCondition = true;
    };
  }, [name, withConsole]);
  var handleIconClick = function handleIconClick(e) {
    if (onClick) {
      onClick(e);
    }
  };
  return /*#__PURE__*/jsxRuntimeExports.jsx("i", _objectSpread({
    className: classNames(classes.root, 'rc-svg-icon', className),
    onClick: handleIconClick,
    role: role,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') handleIconClick(e);
    },
    "aria-hidden": ariaHidden,
    tabIndex: tabIndex
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: svg
    },
    "data-testid": dataTestId
  }, props));
}
var SvgIcon$1 = /*#__PURE__*/memo(SvgIcon);

export { SvgIcon$1 as S };
//# sourceMappingURL=SvgIcon-CKg98T6e.js.map
